import React, { useState } from "react";
import { colors } from "../../../../../../../../themes/Colors";
import { BaseButtons } from "../../../../../../../common-components";
import SearchBar from "../../../../../../../common-components/search-bar/SearchBar";

const SelectAgentPopUp = ({
  display,
  setSelectTeamMemberPopUp,
  teamMemberType,
  setTeamMemberType,
  agentsArray,
  setAgentsArray,
  AssisgnTeamLeader,
}) => {
  const [search, setSearch] = useState("");
  return (
    <div
      style={{
        position: "absolute",
        bottom: 0,
        backgroundColor: "#00000070",
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-end",
        alignItems: "center",
        height: display ? "100%" : 0,
        overflow: "hidden",
        width: "100%",
        transition: "all 0.2s",
      }}
    >
      <div
        style={{
          height: "80%",
          width: 500,
          backgroundColor: colors.white,
          borderTopRightRadius: 20,
          borderTopLeftRadius: 20,
          position: "relative",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            marginTop: 15,
            marginBottom: 10,
            width: "100%",
            textAlign: "center",
            fontSize: 18,
            fontWeight: "bold",
          }}
        >
          SELECT TEAM MEMBER FOR{" "}
          {teamMemberType ? teamMemberType.toLocaleUpperCase() : "loading"}
        </div>
        <div
          style={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div style={{ width: "90%", display: "flex", alignItems: "center" }}>
            <SearchBar
              search={search}
              onSearchChange={(e) => setSearch(e.target.value)}
              size={250}
            />{" "}
            <div style={{ flex: 1 }} />
            <div style={{ marginTop: 5 }}>
              <BaseButtons
                label={"ADD AGENT"}
                borderRadius={8}
                backgroundColor={colors.primaryBlue}
                width={120}
                height={38}
              />
            </div>
          </div>
        </div>
        <div
          style={{
            flex: 1,

            overflowY: "scroll",
            overflowX: "hidden",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          {agentsArray
            ? agentsArray.map((agent, index) => {
                return (
                  <div
                    onClick={() => {
                      AssisgnTeamLeader({ agent });
                      setSelectTeamMemberPopUp(false);
                    }}
                    key={index}
                    style={{
                      width: "90%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      minHeight: 70,
                      marginTop: 20,
                      borderRadius: 8,
                      WebkitBoxShadow: "0px 0px 7px 2px #00000050",
                      backgroundColor: colors.white,
                    }}
                  >
                    <div
                      style={{
                        fontWeight: "bold",
                        fontSize: 18,
                        display: "flex",
                        flexDirection: "column",
                        marginLeft: 20,
                      }}
                    >
                      <div
                        style={{
                          fontSize: 12,
                          fontWeight: "bold",
                          opacity: 0.7,
                        }}
                      >
                        NAME
                      </div>
                      {(
                        agent.firstName +
                        " " +
                        agent.lastName
                      ).toLocaleUpperCase()}
                    </div>

                    <div style={{ flex: 1 }} />
                    <div
                      style={{
                        fontWeight: "bold",
                        fontSize: 14,
                        display: "flex",
                        flexDirection: "column",
                        marginRight: 20,
                      }}
                    >
                      <div
                        style={{
                          fontSize: 12,
                          fontWeight: "bold",
                          opacity: 0.7,
                        }}
                      >
                        TYPE
                      </div>
                      {agent.Team.toLocaleUpperCase()}
                    </div>
                    <div
                      style={{
                        fontWeight: "bold",
                        fontSize: 14,
                        display: "flex",
                        flexDirection: "column",
                        marginRight: 20,
                        textAlign: "left",
                      }}
                    >
                      <div
                        style={{
                          fontSize: 12,
                          fontWeight: "bold",
                          opacity: 0.7,
                        }}
                      >
                        ACCOUT TYPE
                      </div>
                      {agent.type}
                    </div>
                  </div>
                );
              })
            : "loading"}
        </div>
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginBottom: 10,
            marginTop: 10,
          }}
        >
          <BaseButtons
            label={"CANCEL"}
            width={"90%"}
            borderRadius={8}
            backgroundColor={colors.primaryBlue}
            onClick={() => {
              setSelectTeamMemberPopUp(false);
              setTeamMemberType("");
              setAgentsArray(null);
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default SelectAgentPopUp;
